import styled from 'styled-components';

export const LoginPageContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: transparent;
    overflow: hidden;

    @media (min-width: 1024px) {
        flex-direction: row;
    }
`;

export const DesktopPanel = styled.div`
  display: none;
  @media (min-width: 1024px) {
    display: flex;
    flex-direction: column;
    width: 50%;
    flex: 0 0 50%;
    background: linear-gradient(135deg, ${p => p.theme.colors.text.dark} 0%, #111827 100%);
    justify-content: center;
    padding: 60px 80px;
    position: relative;
  }
`;

export const PanelHeading = styled.h1`
  font-family: 'Inter', sans-serif;
  color: ${p => p.theme.colors.background.paper};
  font-size: 28px;
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.5px;
  margin: 0 0 20px 0;
`;

export const PanelDescription = styled.p`
  font-family: 'Inter', sans-serif;
  color: ${p => p.theme.colors.text.disabled};
  font-size: 16px;
  font-weight: 300;
  line-height: 1.7;
  margin: 0 0 60px 0;
  max-width: 420px;
`;

export const DesktopLogoImage = styled.img`
  width: 380px;
  height: auto;
  object-fit: contain;
  filter: brightness(0) invert(1);
  margin-top: 40px;
  margin-bottom: 80px;
`;

export const TrustBadgesRow = styled.div`
  display: flex;
  gap: 48px;
  margin-top: auto;
  margin-bottom: 40px;
`;

export const LegalText = styled.div`
  font-family: 'Inter', sans-serif;
  color: ${p => p.theme.colors.text.disabled};
  font-size: 9px;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  
  p {
    margin: 0 0 10px 0;
    &:last-child {
      margin: 0;
    }
  }
`;

export const TrustBadge = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TrustBadgeIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  color: #ffffff;
`;

export const TrustBadgeTitle = styled.span`
  font-family: 'Inter', sans-serif;
  color: ${p => p.theme.colors.background.paper};
  font-size: 14px;
  font-weight: 600;
`;

export const TrustBadgeDesc = styled.span`
  font-family: 'Inter', sans-serif;
  color: ${p => p.theme.colors.text.secondary};
  font-size: 13px;
  font-weight: 400;
  line-height: 1.4;
  max-width: 180px;
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${p => p.theme.colors.background.paper};
  min-height: 100dvh;
  overflow-y: auto;
  position: relative;

  @media (min-width: 1024px) {
    width: 50%;
    flex: 0 0 50%;
    justify-content: center;
    align-items: center;
    padding: 40px 40px 50px 40px;
  }
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  
  @media (max-width: 1023px) {
    max-width: 100%;
    flex: 1;
  }
`;

export const MobileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 30px 20px 30px;
  text-align: center;

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const MobileLogo = styled.img`
  width: 160px; 
  height: 80px;
  object-fit: contain;
  margin-bottom: 24px;
  filter: ${p => p.theme.isDark ? 'brightness(0) invert(1)' : 'brightness(0)'};
`;

export const FormTitle = styled.h2`
  font-family: 'Inter', sans-serif;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: -0.3px;
  color: ${p => p.theme.colors.text.dark};
  margin: 0 0 4px 0;
  text-align: center;
  padding: 0 30px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

export const FormSubtitle = styled.p`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${p => p.theme.colors.text.secondary};
  margin: 0 0 16px 0;
  text-align: center;
  padding: 0 30px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  padding: 0 30px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

export const InputGroup = styled.div`
  margin-bottom: 20px;
`;

export const InputLabel = styled.label`
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${p => p.theme.colors.text.secondary};
  margin-bottom: 8px;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${p => p.theme.colors.background.paper};
  border-radius: 10px;
  border: 1.5px solid ${p => p.theme.colors.border.main};
  padding: 0 14px;
  transition: all 0.2s ease;

  &:focus-within {
    border-color: ${p => p.theme.colors.text.primary};
    box-shadow: 0 0 0 3px ${p => p.theme.colors.background.selected};
  }
`;

export const InputIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${p => p.theme.colors.text.secondary};
  margin-right: 10px;
  flex-shrink: 0;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 14px 0;
  border: none;
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  background-color: transparent;
  color: ${p => p.theme.colors.text.primary};

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${p => p.theme.colors.text.disabled};
    font-weight: 400;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 28px;
  width: 100%;
  
  button {
    &:focus-visible {
      outline: 2px solid #3b82f6;
      outline-offset: 2px;
    }
  }
`;

export const ButtonContent = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const FooterRow = styled.div`
  font-family: 'Inter', sans-serif;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 30px;
  font-size: 13px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`;

export const FooterAction = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  color: ${p => p.theme.colors.text.secondary};
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: ${p => p.theme.colors.text.dark};
    text-decoration: underline;
  }
  
  &:focus-visible {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const LegalFooter = styled.div`
  font-family: 'Inter', sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  font-size: 11px;
  color: ${p => p.theme.colors.text.disabled};
  white-space: nowrap;

  @media (min-width: 1024px) {
    position: absolute;
    bottom: 12px;
    left: 0;
    right: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      color: ${p => p.theme.colors.primary.light};
    }
    &:focus-visible {
      outline: 2px solid #3b82f6;
      outline-offset: 2px;
      border-radius: 2px;
    }
  }
`;
